// --------------------------------------------------------
//  DÉCLARATION DES CONSTANTES
// --------------------------------------------------------
//
// PARAMÈTRES PASSÉS PAR LA COMPAGNIE (via le HTML et l'objet window.lsresa)
export const cie = window.lsresa.cie;

export const ar_journee = window.lsresa.ar_journee ? window.lsresa.ar_journee : false;
console.log("ar_journee", ar_journee);

export const affiche_etapes = window.lsresa.affiche_etapes ? window.lsresa.affiche_etapes : false;
//console.log('affiche_etapes', affiche_etapes);

export const affiche_dispo = window.lsresa.affiche_dispo ? window.lsresa.affiche_dispo : false;
//console.log('affiche_dispo', affiche_dispo);

export const affiche_tps_traversee = window.lsresa.affiche_tps_traversee ? true : false;
//console.log('affiche_tps_traversee', affiche_tps_traversee);

export const tab_croisieres_aller = window.lsresa.croisiere[0].split('.'); // Le paramètre croisiere peut contenir plusieur codes croisières : on les récupère dans un tableau de croisieres
//console.log('tab_croisieres_aller', tab_croisieres_aller);

export var tab_croisieres_retour;
export let id_voyage_ar; // ex. : 'ARDMUL;1ASF;1RSF'

export const affiliation = window.lsresa.affiliation ? window.lsresa.affiliation : false;
//console.log("affiliation : ", affiliation);

if (
	// Si une croisière retour est configurée dans les options, on prépare les constantes…
	typeof window.lsresa.croisiere_retour !== 'undefined' &&
	window.lsresa.croisiere_retour !== '' &&
	window.lsresa.croisiere_retour.length === 2
) {
	tab_croisieres_retour = window.lsresa.croisiere_retour[0].split('.'); // On veut un tableau de croisières
	console.log('tab_croisieres_retour', tab_croisieres_retour);
	id_voyage_ar = window.lsresa.croisiere_retour[1];
	console.log('id_voyage_ar', id_voyage_ar);
}

export const BASE_URL_RESA = window.lsresa.url_reservation;

// Autres constantes (URL API, mode, etc. )

export let mode = 'prod'; // Par defaut (ne pas toucher)
if (window.lsresa.mode !== undefined && window.lsresa.mode === 'dev') {
	// Ne sert qu'à LS-Résa : ce param ne doit pas être donné au client
	mode = 'dev';
}

const BASE_URL = mode === 'dev' ? 'https://api-dev.ls-resa.fr' : 'https://api.ls-resa.fr';
//export const TOKEN_URL = BASE_URL + '/auth/realms/LSRest2/protocol/openid-connect/token';
export const END_POINT = BASE_URL + '/LSRest2/' + cie + '/LS_CROISIERE';

// --------------------------------------------------------
//  INSERTION DE LA FEUILLE DE STYLE DANS LE DOM
// --------------------------------------------------------
// On ajoute une feuille de style ls_styles.css dans la balise <head> du site hôte
// ATTENTION au href entre la dev et la prod !


const css_href = mode === 'dev' ? 'css/ls_styles.css' : 'https://repo.ls-resa.fr/css/ls_styles.css?ver=1216';

const ls_styles = lsCreateElement('link', {
	rel: 'stylesheet',
	type: 'text/css',
	href: css_href,
});
document.head.appendChild(ls_styles);

// --------------------------------------------------------
//  CRÉATION D'ÉLÉMENTS DU DOM POUR L'AFFICHEUR
// --------------------------------------------------------

// CONTENEUR MAÎTRE
const ls_container = lsCreateElement('section', { class: 'ls-container' }); // Ce container contient TOUT et s'insère dans la div paramétrée par le client.
// on tague ce conteneur avec une classe pour identifier la cie
// lsaw = ls afficheur web
ls_container.classList.add(`lsaw-${cie}`);

export let title = lsCreateElement('h2', { class: 'ls-title' }); // Titre principal
ls_container.prepend(title);

const ls_display = lsCreateElement('div', { class: 'ls-displays' }); // div.ls-displays est le conteneur flex qui contiendra une div pour les allers et une autres pour les retours (si option retour choisie)

export const tab_allers = lsCreateElement('div', { class: 'bloc allers' }); // la div qui reçoit les horaires aller
export const tab_retours = lsCreateElement('div', { class: 'bloc retours' }); // la div qui reçoit les horaires retour (si option pour croisière retour)

let insertion_point;
// On insère le conteneur principal (qui contient tout) dans le DOM
if (window.lsresa.container_id !== undefined && window.lsresa.container_id !== '') {
	insertion_point = document.getElementById(window.lsresa.container_id);
	insertion_point.append(ls_container);
} else {
	document.body.append(ls_container);
}
ls_container.append(ls_display);
//ls_display.append(tab_allers, tab_retours);
ls_display.append(tab_allers);
if (typeof window.lsresa.croisiere_retour !== 'undefined') {
	ls_display.append(tab_retours);
}

// --------------------------------------------------------
//  AFFICHAGE DES INFOS EN ENTÊTE (Titre, légende)
// --------------------------------------------------------

const legende_dispo = `
		<div class= "ls-header">
      <h4 class="header-title"></h4>
		<p class="legende-dispo">
			<span>Légende :</span> <span class="heure-depart dispo-ok">&nbsp;&nbsp;</span><span class="legend">Disponible</span>
			<span class="heure-depart presque-complet">&nbsp;&nbsp;</span><span class="legend">Forte demande</span>
			<span class="heure-depart complet">&nbsp;&nbsp;</span><span class="legend">Complet</span>
		</p>
	</div> `;
const legende = lsCreateElement('div', { class: 'ls-legende' });
ls_container.insertBefore(legende, ls_display);
legende.innerHTML = legende_dispo;

// -------------------------------------------------------)
//  GESTION DES ERREURS
// --------------------------------------------------------
// On crée un conteneur pour afficher les erreurs

export const error_container = lsCreateElement('div', { class: 'ls-error-container' });
legende.append(error_container);

// --------------------------------------------------------
// CONSTRUCTION DU SELECT DES MOIS.
// --------------------------------------------------------

const p_select_mois = lsCreateElement('p', { class: 'ls-select-mois' });
export const select_mois = lsCreateElement('select');

let incitation; // On envoie pas le même texte si AS ou AR (≠ ARDMUL) ou si AS+RS
if (window.lsresa.croisiere_retour !== undefined) {
	incitation = `<span class="incitation">Cliquez sur un <b>horaire aller</b> puis sur un <b>horaire retour</b> pour réserver…</span>`;
} else {
	incitation = `<span class="incitation">Cliquez sur un horaire, pour réserver…</span>`;
}

p_select_mois.textContent = 'Affichez les départs pour : ';
legende.appendChild(p_select_mois);
p_select_mois.append(select_mois);
select_mois.insertAdjacentHTML('afterend', incitation);

// --------------------------------------------------------
//  FONCTIONS
// --------------------------------------------------------

/**
 * Fonction générique pour créer des élements HTML dans le DOM
 * @param {string} tagname HTML
 * @param {Object} attributes (classes, id, type, rel, etc.)
 * @returns {HTMLElement}
 */

export function lsCreateElement(tagname, attributes = {}) {
	const element = document.createElement(tagname);
	for (const [att, value] of Object.entries(attributes)) {
		element.setAttribute(att, value);
	}
	return element;
}

/**
 * Supprime les alertes de classe "ls-alert"
 */
export function reset_alert() {
	if (document.querySelector('.ls-alert') !== null) {
		document.querySelector('.ls-alert').remove();
	}
}

/**
 * Affiche une alerte (supprime d'abord l'alerte existante et la remplace)
 * @param {string} msg
 * @param {string} container Le conteneur qui reçoit l'alerte
 * @param {*} containers_to_reset Les container à éventuellement vider de leur contenu
 * @returns {string} msg
 */
export function display_alert(msg, container, containers_to_reset = []) {
	reset_alert();
	const alert = `<div class="ls-alert"><p>${msg}</p></div> `;
	container.innerHTML = alert;
	for (let container of containers_to_reset) {
		container.innerHTML = '';
	}
	return msg;
}

/**
 * CLASSE CSS POUR LA DISPO
 * @param {number} taux_occup (entre 0 et 1)
 * @returns {string} : une classe css qui sera utilis&ée dans la fonction display_ligne_horaire()
 */
export function classDispo(taux_occup) {
	let css_dispo = '';
	if (taux_occup >= 0 && taux_occup < 0.85) {
		css_dispo = 'dispo-ok';
	} else if (taux_occup >= 0.85 && taux_occup < 1) {
		css_dispo = 'forte-demande';
	} else {
		// taux_occup == 1
		if (ar_journee) {
			css_dispo = 'dispo-ok'; // Pour les AR Journée, 1 seul horaire en représente plusieurs, donc jamais complets sinon on peut bloquer des ventes.
		} else {
			css_dispo = 'complet';
		}

	}
	return css_dispo;
}